import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Transition as _Transition, Teleport as _Teleport } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12 3.75C7.44365 3.75 3.75 7.44365 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25C16.5563 20.25 20.25 16.5563 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75ZM2.25 12C2.25 6.61522 6.61522 2.25 12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12ZM9.21967 9.21967C9.51256 8.92678 9.98744 8.92678 10.2803 9.21967L12 10.9393L13.7197 9.21967C14.0126 8.92678 14.4874 8.92678 14.7803 9.21967C15.0732 9.51256 15.0732 9.98744 14.7803 10.2803L13.0607 12L14.7803 13.7197C15.0732 14.0126 15.0732 14.4874 14.7803 14.7803C14.4874 15.0732 14.0126 15.0732 13.7197 14.7803L12 13.0607L10.2803 14.7803C9.98744 15.0732 9.51256 15.0732 9.21967 14.7803C8.92678 14.4874 8.92678 14.0126 9.21967 13.7197L10.9393 12L9.21967 10.2803C8.92678 9.98744 8.92678 9.51256 9.21967 9.21967Z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "file-preview-modal__content" }
const _hoisted_6 = { class: "file-preview-modal__layer" }
const _hoisted_7 = { class: "file-preview-modal__bottom" }
const _hoisted_8 = {
  key: 0,
  class: "file-preview-modal__bottom-image"
}
const _hoisted_9 = { class: "file-preview-modal__filename" }
const _hoisted_10 = { class: "file-preview-modal__image-controls" }
const _hoisted_11 = {
  key: 0,
  class: "file-preview-modal__image-container"
}
const _hoisted_12 = ["src", "alt"]
const _hoisted_13 = {
  key: 0,
  class: "file-preview-modal__bottom-carousel"
}
const _hoisted_14 = { class: "file-preview-modal__bottom-carousel-content" }

import {
  computed,
  PropType,
  onUnmounted,
  onMounted,
  ref,
} from "vue";
import {
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
} from "tir-components";
import {
  CrossCompactIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  PencilSquareIcon,
  ArrowDownTrayIcon,
  ArrowsPointingOutIcon,
  ArrowsPointingInIcon,
} from "tir-style-system/icons/outline";
import { IFilePreview } from "../../interfaces";
import { FileTypeEnum, FilePreviewAccessEnum } from "../../enums";
import { imageExtensions, videoExtensitons } from "../../constants";
import { downloadFile, getFileExtension } from "../../utils";
import { FilePreviewCarousel } from "../file-preview-carousel";
import { TirPmVideoPlayer, VideoModel } from "tir-pm-video-player";
import { FilePreviewEditNamePopover } from "../file-preview-edit-name-popover";

/**События */

export default /*#__PURE__*/_defineComponent({
  __name: 'file-preview-modal',
  props: {
  /**Файл */
  file: {
    type: Object as PropType<T>,
  },
  /**Список файлов */
  files: {
    type: Array as PropType<Array<IFilePreview>>,
    default: [],
  },
  /**Загрузка при редактировании названия */
  filesLoadingEditName: {
    type: Array as PropType<Array<T["FileId"]>>,
    default: [],
  },
  /**Отображать кнопку вперед */
  isViewNext: {
    type: Boolean,
    default: false,
  },
  /**Отображать кнопку назад */
  isViewPrev: {
    type: Boolean,
    default: false,
  },
  /**Полноэкранный режим */
  fullScreen: {
    type: Boolean,
    default: false,
  },
},
  emits: ["close", "onClickDownload", "onClickNext", "onClickPrev", "update:file", "update:fullScreen", "onClickEdit", "saveName"],
  setup(__props, { emit }) {

const props = __props;





/**Ссылка на поповер редактирования названия файла */
const $editNamePopover = ref<InstanceType<typeof FilePreviewEditNamePopover>>();
/**Открыт ли поповер редактирования названия файла */
const isOpenedEditNamePopover = ref(false);
/**При клике на кнопку редактирования */
const onClickEdit = () => {
  // Если изображение
  if (imageExtensions.includes(fileExtension.value) && !['gif', 'svg'].includes(fileExtension.value)) {
    emit("close");
    emit("onClickEdit", fileInfo.value.FileId);
  } else {
    $editNamePopover.value?.open();
  }
};

const fileInfo = computed(() => props.file as T | undefined);

const onClickDocument = (e: any) => {
  if (!e?.target?.closest(".file-preview-modal__edit-button")) {
    document.body.click();
  }
};

/**Расщирение файла */
const fileExtension = computed(() => {
  return getFileExtension(fileInfo.value.Name);
});
/**Название файла (без расширения) */
const fileName = computed(() => {
  const lastDotIndex = fileInfo.value.Name.lastIndexOf(".");
  if (lastDotIndex === -1) return fileInfo.value.Name; // Если точки нет, возвращаем исходное имя
  return fileInfo.value.Name.substring(0, lastDotIndex);
});
/**Информация о видео */
const videoInfo = computed(() => {
  return new VideoModel({
    Link: fileInfo.value?.Url,
    Name: fileInfo.value?.Name,
    AutoPlay: true,
  });
});
/**Тип файла */
const fileType = computed(() => {
  switch (true) {
    case imageExtensions.includes(fileExtension.value):
      return FileTypeEnum.Image;
    case videoExtensitons.includes(fileExtension.value):
      return FileTypeEnum.Video;
    default:
      return FileTypeEnum.Other;
  }
});

/**При закрытии на оверлее */
const onCloseFromOverlay = () => {
  emit("close");
};

const download = () => {
  downloadFile(fileInfo.value.Url, `${fileInfo.value.Name}`);
};

const onKeyDown = (e: KeyboardEvent) => {
  if (!props.file) return;

  if (e.key === "Escape") {
    emit("close");
    return;
  }

  if (["ArrowLeft", "a"].includes(e.key)) {
    e.preventDefault();
    emit("onClickPrev");
    return;
  }
  if (["ArrowRight", "d"].includes(e.key)) {
    e.preventDefault();
    emit("onClickNext");
    return;
  }
};

onMounted(() => {
  window.addEventListener("keydown", onKeyDown);
});

onUnmounted(() => {
  if (props.file) {
    emit("close");
    document.body.style.removeProperty("overflow");
  }
  window.removeEventListener("keydown", onKeyDown);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "file-preview-modal__visible" }, {
      default: _withCtx(() => [
        (__props.file)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(['file-preview-modal__overlay', { 'full-screen': __props.fullScreen }]),
              onMousedown: onCloseFromOverlay
            }, [
              _createElementVNode("div", {
                class: _normalizeClass([
            'file-preview-modal',
            {
              'full-screen': __props.fullScreen,
            },
          ]),
                onClick: _withModifiers(onClickDocument, ["stop"]),
                onMousedown: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createVNode(_unref(TirPmButton), {
                  class: "file-preview-modal__close-button",
                  variant: _unref(TirPmButtonVariantEnum).TertiaryState,
                  size: 
              __props.fullScreen ? _unref(TirPmButtonSizeEnum).Big : _unref(TirPmButtonSizeEnum).Middle
            ,
                  "is-rounded": !__props.fullScreen,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
                }, {
                  leftSlot: _withCtx(() => [
                    (!__props.fullScreen)
                      ? (_openBlock(), _createBlock(_unref(CrossCompactIcon), { key: 0 }))
                      : (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_4))
                  ]),
                  _: 1
                }, 8, ["variant", "size", "is-rounded"]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    (__props.isViewPrev && !__props.fullScreen)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "file-preview-modal__slider-button left-button",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('onClickPrev')))
                        }, [
                          _createVNode(_unref(ChevronLeftIcon), { class: "file-preview-modal__slider-button-icon" })
                        ]))
                      : _createCommentVNode("", true),
                    (__props.isViewNext && !__props.fullScreen)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "file-preview-modal__slider-button right-button",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('onClickNext')))
                        }, [
                          _createVNode(_unref(ChevronRightIcon), { class: "file-preview-modal__slider-button-icon" })
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_7, [
                      (fileType.value === _unref(FileTypeEnum).Image)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createElementVNode("span", _hoisted_9, _toDisplayString(fileName.value) + "." + _toDisplayString(fileExtension.value), 1),
                            _createElementVNode("div", _hoisted_10, [
                              (
                        fileInfo.value.Accesses?.includes(_unref(FilePreviewAccessEnum).Edit)
                      )
                                ? (_openBlock(), _createBlock(_unref(FilePreviewEditNamePopover), {
                                    key: 0,
                                    ref_key: "$editNamePopover",
                                    ref: $editNamePopover,
                                    "is-opened": isOpenedEditNamePopover.value,
                                    "onUpdate:isOpened": _cache[3] || (_cache[3] = ($event: any) => ((isOpenedEditNamePopover).value = $event)),
                                    "is-loading": 
                        __props.filesLoadingEditName.includes(fileInfo.value.FileId)
                      ,
                                    "file-name": fileInfo.value.Name,
                                    onSaveFileName: _cache[4] || (_cache[4] = ($event: any) => (
                        emit('saveName', fileInfo.value.FileId, $event)
                      ))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(TirPmButton), {
                                        class: "file-preview-modal__edit-button",
                                        size: _unref(TirPmButtonSizeEnum).Small,
                                        variant: _unref(TirPmButtonVariantEnum).PrimaryState,
                                        onClick: _withModifiers(onClickEdit, ["stop"])
                                      }, {
                                        leftSlot: _withCtx(() => [
                                          _createVNode(_unref(PencilSquareIcon))
                                        ]),
                                        _: 1
                                      }, 8, ["size", "variant", "onClick"])
                                    ]),
                                    _: 1
                                  }, 8, ["is-opened", "is-loading", "file-name"]))
                                : _createCommentVNode("", true),
                              _createVNode(_unref(TirPmButton), {
                                size: _unref(TirPmButtonSizeEnum).Small,
                                variant: _unref(TirPmButtonVariantEnum).PrimaryState,
                                onClick: download
                              }, {
                                leftSlot: _withCtx(() => [
                                  _createVNode(_unref(ArrowDownTrayIcon))
                                ]),
                                _: 1
                              }, 8, ["size", "variant"]),
                              _createVNode(_unref(TirPmButton), {
                                size: _unref(TirPmButtonSizeEnum).Small,
                                variant: _unref(TirPmButtonVariantEnum).PrimaryState,
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (emit('update:fullScreen', !__props.fullScreen)))
                              }, {
                                leftSlot: _withCtx(() => [
                                  (!__props.fullScreen)
                                    ? (_openBlock(), _createBlock(_unref(ArrowsPointingOutIcon), { key: 0 }))
                                    : (_openBlock(), _createBlock(_unref(ArrowsPointingInIcon), { key: 1 }))
                                ]),
                                _: 1
                              }, 8, ["size", "variant"])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  (fileType.value === _unref(FileTypeEnum).Image)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("img", {
                          class: "file-preview-modal__image",
                          src: fileInfo.value.Url,
                          alt: fileInfo.value.Name
                        }, null, 8, _hoisted_12)
                      ]))
                    : _createCommentVNode("", true),
                  (fileType.value === _unref(FileTypeEnum).Video)
                    ? (_openBlock(), _createBlock(_unref(TirPmVideoPlayer), {
                        key: 1,
                        video: videoInfo.value,
                        onUpdateName: _cache[6] || (_cache[6] = ($event: any) => (emit('saveName', fileInfo.value.FileId, $event))),
                        onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
                      }, null, 8, ["video"]))
                    : _createCommentVNode("", true)
                ]),
                (__props.files.length > 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        (__props.isViewPrev && __props.fullScreen)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "file-preview-modal__bottom-carousel-button left-button",
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (emit('onClickPrev')))
                            }, [
                              _createVNode(_unref(ChevronLeftIcon), { class: "file-preview-modal__bottom-carousel-icon" })
                            ]))
                          : _createCommentVNode("", true),
                        (__props.isViewNext && __props.fullScreen)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: "file-preview-modal__bottom-carousel-button right-button",
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (emit('onClickNext')))
                            }, [
                              _createVNode(_unref(ChevronRightIcon), { class: "file-preview-modal__bottom-carousel-icon" })
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode(_unref(FilePreviewCarousel), {
                          files: __props.files,
                          "selected-file": fileInfo.value,
                          onSelectFile: _cache[10] || (_cache[10] = ($event: any) => (emit('update:file', $event)))
                        }, null, 8, ["files", "selected-file"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 42, _hoisted_1)
            ], 34))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})